import Echo from 'laravel-echo'

import Pusher from 'pusher-js'
window.Pusher = Pusher

// Determine the token based on the current URL path
const path = window.location.pathname
let token = ''

if (path.startsWith('/retailer')) {
  token = localStorage.getItem('retailer_access_token')
} else if (path.startsWith('/admin')) {
  token = localStorage.getItem('user_access_token')
}

window.Echo = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: import.meta.env.VITE_REVERB_PORT,
  wssPort: import.meta.env.VITE_REVERB_PORT,
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  enabledTransports: ['ws', 'wss'],
  authEndpoint: import.meta.env.VITE_BROADCASTING_URL,
  auth: {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }
})